<template>
  <div class="icon feefo-icon">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.43 67.56">
      <path d="M0,24.7l28.22,25.43,28.22-25.43H0Z" />
      <path d="M0,24.7H27.81S27.81,0,27.81,0L0,24.7Z" />
      <path d="M56.43,24.7H27.81s0,25.43,0,25.43l28.62-25.43Z" />
      <path d="M48.25,67.56l-20.04-17.44-20.04,17.44H48.25Z" />
    </svg>
  </div>
</template>
